import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function postalCodeValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // This regular expression will validate that the postal code is from Spain or Portugal.
      // XXXXX (Spain) or XXXX-XXX (Portugal)
      const postalCodeRegexRegExp: RegExp= /^([0-9]{5})?(^[0-9]{4}(?:-[0-9]{3}))?$/;
      const isPostalCodeValid = postalCodeRegexRegExp.test(control.value);
      return !isPostalCodeValid ? {'postalCodeError': {value: control.value}} : null;
    };
  }